module.exports = __webpack_public_path__ + "img/portfolio3.279661da.png";